// extracted by mini-css-extract-plugin
export default {"myProjectsBlock":"MyProjects_myProjectsBlock__EjNDE","myProjectsContainer":"MyProjects_myProjectsContainer__rgrZt","myProjects":"MyProjects_myProjects__PFs0O"};